import React, {Component} from 'react';
import {Avatar} from 'react-native-elements'
import {createAppContainer, NavigationActions } from 'react-navigation';
import {FlatList, TouchableOpacity, Text, TextInput, Button, Animated, Platform, StyleSheet, View, ScrollView, Image, Alert, ImageBackground} from 'react-native';

import firebase from 'firebase'
// GoogleSignin.configure();
import './firebase_app'
import {styles, profileStyles} from './Styles'


const profile_logo_list = [
  require('../img/gradient.jpg'),
]

class ProfileScreen extends React.Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   "photo_url": user.photoURL
    // }
    console.log(this.state)

  }

  logOut() {
    firebase.auth().signOut().then(() => {
          this.props.navigation.reset([NavigationActions.navigate({
              routeName: 'Login'
            })], 0);
    }).catch(function(error) {
      // An error happened.
    });
  }

  render() {
    var user = firebase.auth().currentUser;
    // console.log(user.email)
    return (
      <View>
      <ImageBackground source={profile_logo_list[0]} resizeMode='stretch' style={{width: "100%", "height": 200, alignItems: 'center'}}>
        <Text style={profileStyles.profileName}>{user.displayName}</Text>
        <Avatar
          rounded
          source={{ uri: user && user.photoURL }}
          size={150}
          containerStyle={profileStyles.avatar}
        >
        </Avatar>
      </ImageBackground>
      <Text style={profileStyles.header}>
        Total de atividades
      </Text>
      <View style={{flexDirection: 'row', alignItems: 'center', width: "100%", alignItems: 'center', justifyContent: 'center'}}>
        <View style={profileStyles.modalityView}>
          <Text style={profileStyles.modalityText}>Areia</Text>
          <Text style={profileStyles.numberText}>0</Text>
        </View>
        <View style={profileStyles.modalityView}>
          <Text style={profileStyles.modalityText}>Padel</Text>
          <Text style={profileStyles.numberText}>0</Text>
        </View>
        <View style={profileStyles.modalityView}>
          <Text style={profileStyles.modalityText}>Churrasqueira</Text>
          <Text style={profileStyles.numberText}>0</Text>
        </View>
      </View>
      <View style={{marginTop: 10, width: 250}}>
      </View>
      <Button
        title="Logout"
        onPress={() => this.logOut()}
        buttonStyle={{
          backgroundColor: "#8a3146"
        }}
        buttonContainerStyle={{
          width: 80,
          height: 40,
          borderRadius: 40,
          backgroundColor: "#8a3146"
        }}
      >
      </Button>
      <Button
        title="Atualizar perfil"
        onPress={() => db.ref('/first/' + user.uid).remove().then(this.props.navigation.reset([NavigationActions.navigate({
            routeName: 'Tab'
          })], 0))}
      ></Button>
      </View>
    );
  }
}

const ProfileContainer = createAppContainer(ProfileScreen);

export default ProfileContainer;
